import { Stack } from '@mui/material';
import { ModelRuns } from '../../types';
import Chip from '../Chip';

const modelRunsTotalsRenderer = (value: ModelRuns) => (
  <Stack direction="row" sx={{ gap: 1 }}>
    {value.totals?.success > 0 && (
      <Chip label={value.totals?.success} color="success" />
    )}
    {value.totals?.errors > 0 && (
      <Chip label={value.totals?.errors} color="error" />
    )}
  </Stack>
);

export default modelRunsTotalsRenderer;
